import React from 'react';
import moment from 'moment';
import { StyleSheet } from 'react-native';
import TitleSummaryList from './TitleSummary';
import SummaryList from './SummaryList';
import { formatCurrency } from '../../utils/currency.utils';
import { AirCard, AirCardCloud } from '../resultCards';
import BaseText from '../BaseText';
import { CommonStyles } from '../../styles';
import RowView from '../RowView';
import { cardStyle } from '../resultCards/card.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { selectChangeRes, selectNoOfTravelers } from '../../store/selectors/search.selector';
import { useDateFormat } from '../../utils/useDateFormat';
import { useSelector } from 'react-redux';
import { getTotalDuration } from '../../utils/time.utils';
import { selectAirlinesCloud } from '../../store/selectors/air.selector';

const getTravelCount = ({ NoOfAdults = 0, NoOfSeniors = 0, NoOfChildren = 0 }) => {
  return NoOfAdults + NoOfSeniors + NoOfChildren;
};

const AirSummaryList = ({ response, price, onSelect, currency, currencyCulture, redeem }) => {
  const { t } = useTranslation(i18nNS.tripSummary);
  const { tKey } = useComponentTKey('AirSummaryList');
  const formatDate = useDateFormat();
  const ChangeRes = useSelector(selectChangeRes);
  const noOfTravelers = useSelector(selectNoOfTravelers);
  const travelerCount = getTravelCount(response) || noOfTravelers;
  const airlines = useSelector(selectAirlinesCloud);
  return (
    <>
      {!ChangeRes && (
        <TitleSummaryList
          desc={
            travelerCount === 0
              ? ''
              : travelerCount +
                ' ' +
                (travelerCount > 1 ? t(tKey('Travelers')) : t(tKey('Traveler')))
          }
          amount={
            redeem
              ? response.RedeemPoints + ' pts'
              : formatCurrency(price, currency, currencyCulture)
          }
          iconName="flight"
        />
      )}
      <SummaryList style={styles.airTitleStyle}>
        {response?.AirLegs[0]?.id
          ? response?.AirLegs?.map((flight, index) => (
              <AirCardCloud
                key={index}
                onPress={onSelect}
                legIndex={0}
                flight={flight}
                textUpIcon={formatDate(flight?.legs[0]?.flights[0]?.departureDate)}
                childrenTitle={
                  <RowView style={CommonStyles.mt2}>
                    <BaseText style={CommonStyles.mr3}>
                      {flight?.legs[0]?.isMultipleAirline
                        ? t(tKey('MultipleAirlines'))
                        : airlines?.find(
                            (airline) => airline.code === flight?.legs[0]?.flights[0]?.marketting
                          )?.name}
                    </BaseText>
                    <BaseText style={cardStyle.grayColor}>
                      {getTotalDuration(flight?.legs[0]?.totalDuration)}
                    </BaseText>
                  </RowView>
                }
                disableDetails
                hidePrice
                currency={currency}
                currencyCulture={currencyCulture}
              />
            ))
          : response?.AirLegs &&
            response?.AirLegs?.map((leg, index) => (
              <AirCard
                key={leg.LegNumber}
                onPress={onSelect}
                legIndex={index}
                flight={response}
                textUpIcon={leg?.AirSegments?.[0] && formatDate(leg?.AirSegments[0]?.DepartureDate)}
                childrenTitle={
                  <RowView style={CommonStyles.mt2}>
                    <BaseText style={CommonStyles.mr3}>
                      {leg?.IsMultipleAirline
                        ? t(tKey('MultipleAirlines'))
                        : leg?.AirSegments[0]?.AirlineName}
                    </BaseText>
                    <BaseText style={cardStyle.grayColor}>{leg?.TotalDuration}</BaseText>
                  </RowView>
                }
                disableDetails
                hidePrice
                currency={currency}
                currencyCulture={currencyCulture}
              />
            ))}
      </SummaryList>
    </>
  );
};

const styles = StyleSheet.create({
  airTitleStyle: {
    marginBottom: 100,
  },
});

export default AirSummaryList;
